module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA9ElEQVR42uVRO0oEQRR8GigmmupNDBT6jdOvu1ojoSNBcO8gGM4NFAVvIIh4Bj+xJmIuHkOj8VVg4KrrzqYWFN3UD2ZaNOeiMV+p4WII2WFXmlQOXHh3joJhbxoy63zjKYRaOXTjua11Rf4AM8yy88VoIk404g7A4m9lemq494Hjb2bf93P8LrLruvlxn5qXr52XzMpPqLUuhJhvPXQ67oWIs2D5hhmZBADLanhqLB99arxToyfTIKXdNY141YR9kndqMgRtzhtqeAwRD1tpe5PawIGdwFfhP/EB/ecDfQuszzTAshrOZRaUUlaD5Zda69Kk3AfH04gZbmZtIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/icn-marketing_1x.png
// module id = 2297
// module chunks = 0